import ApiService from "./apiService";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/26/20
 * Time: 10:30 AM
 */


export async function getClassDetailsById(data) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication= false;
    apiObject.endpoint = `student/public/class/${data}`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function getClassDetailsByIdWithToken(data) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication= true;
    apiObject.endpoint = `student/public/class/${data}`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function enrollUsingCard(body) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/class/enroll`;
    apiObject.body = body;
    return await ApiService.callApi(apiObject);
}

export async function enrollUsingSlip(body) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/class/enroll/deposit`;
    apiObject.body = body;
    return await ApiService.callApi(apiObject);
}

export async function enrollClassPayment(body) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/class/enroll/payment`;
    apiObject.body = body;
    return await ApiService.callApi(apiObject);
}

export async function getAllEnrolledClass(pagination) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/class/enroll?page=${pagination.page}&size=${pagination.size}`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function joinZoomClasses(data){
    const apiObject ={};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/public/class/zoom/join?hash=${data.hCode}&mobile=${data.mobile}&password=${data.password}`;
    return await ApiService.callApi(apiObject);
}

export async function joinZoomClass(data) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/class/enroll/${data}/join`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function joinZoomClassAuthorized(data) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/class/enroll/authorized/joinZoom/${data}`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function paymentUrlNavigation(hashcode) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `home/view-class/${hashcode}`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
    //https://teachme.ceyentra.lk/api/v1/home/view-class/{hashCode}
}

export async function joinFreeClass(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/class/enroll/free`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}


export async function JoinClassNavigation(hashcode) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `home/join-class/${hashcode}`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
    //https://teachme.ceyentra.lk/api/v1/home/join-class/{hashCode}
}


export async function getClassDetailsByHashcode(hashcode) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `home/class/${hashcode}`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}
